import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { X } from 'lucide-react';
import MarketPulseProductDocContent from './MarketPulseProductDocContent';

interface MarketPulseProductDocModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const MarketPulseProductDocModal: React.FC<MarketPulseProductDocModalProps> = ({ isOpen, onClose }) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };

    if (isOpen) {
      document.addEventListener('keydown', handleEscape);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <>
      <div
        className="fixed inset-0 bg-black/65 backdrop-blur-[2px] transition-opacity"
        style={{ zIndex: 1000000 }}
        onClick={onClose}
        aria-hidden="true"
      />

      <div
        className="fixed inset-0 flex items-stretch justify-center p-0 sm:p-4 md:p-6"
        style={{ zIndex: 1000001 }}
      >
        <div
          className="relative flex flex-col w-full max-w-4xl h-full bg-[#dfe3eb] sm:rounded-2xl shadow-2xl overflow-hidden animate-fadeIn"
          role="dialog"
          aria-modal="true"
          aria-label="کاتالوگ محصول نبض بازار"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="sticky top-0 z-10 flex items-center justify-between gap-4 px-4 sm:px-6 py-3 border-b border-[#e7eaf0] bg-white/95 backdrop-blur-md shrink-0">
            <div className="flex items-center gap-3 min-w-0">
              <span className="hidden sm:inline-flex items-center justify-center w-8 h-8 rounded-xl bg-[#ede9fe] text-[#7c3aed] text-xs font-black shrink-0">
                SX
              </span>
              <div className="min-w-0">
                <h2 className="text-sm sm:text-base font-bold text-[#101828] truncate">
                  کاتالوگ محصول نبض بازار
                </h2>
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="rounded-full w-10 h-10 hover:bg-red-500/10 hover:shadow-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-red-500 flex items-center justify-center shrink-0"
              aria-label="بستن سند محصول"
            >
              <X size={22} className="text-red-500" />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto overscroll-contain px-3 sm:px-5 py-4 sm:py-5">
            <MarketPulseProductDocContent />
          </div>
        </div>
      </div>
    </>,
    document.body
  );
};

export default MarketPulseProductDocModal;
